import { Link } from "react-router-dom";
import { Activity, History, BarChart3, Settings } from "lucide-react";
import { Button } from "../ui/button";

export default function AppHeader({
  selectedPatient,
  onPatientHistory,
  onAllReports,
  onLogoClick,
  rightExtra,
  user,
}) {
  return (
    <header
      data-testid="app-header"
      className="bg-white border-b border-slate-200/80 sticky top-0 z-30 backdrop-blur-xl bg-white/85"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between gap-3">
        <div className="flex items-center gap-4 min-w-0">
          <button
            onClick={onLogoClick}
            data-testid="app-logo-btn"
            className="flex items-center gap-2 group"
          >
            <span className="inline-flex items-center justify-center w-8 h-8 rounded-xl bg-[#10B981] text-white shadow-[0_4px_12px_rgba(16,185,129,0.3)] group-hover:scale-105 transition-transform">
              <Activity className="w-4 h-4" strokeWidth={2.5} />
            </span>
            <span className="hidden sm:inline font-outfit text-lg font-bold tracking-tight text-[#0F172A]">
              TherapyNote
            </span>
          </button>

          {selectedPatient && (
            <div
              data-testid="app-header-patient-chip"
              className="hidden md:flex items-center gap-2 pl-4 ml-1 border-l border-slate-200"
            >
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#D1FAE5] text-[#065F46] font-outfit text-xs font-bold">
                {selectedPatient.initials}
              </span>
              <div className="leading-tight">
                <div className="font-figtree text-xs text-[#94A3B8]">Patient</div>
                <div className="font-outfit text-sm font-semibold text-[#0F172A]">
                  {selectedPatient.id}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="flex items-center gap-1 sm:gap-2">
          <Button
            data-testid="header-history-btn"
            variant="ghost"
            onClick={onPatientHistory}
            className="rounded-full font-figtree text-xs sm:text-sm font-medium text-[#475569] hover:text-[#059669] hover:bg-[#F0FDF4] px-3 sm:px-4"
          >
            <History className="w-4 h-4 sm:mr-1.5" />
            <span className="hidden sm:inline">Patient History</span>
          </Button>
          <Button
            data-testid="header-reports-btn"
            variant="ghost"
            onClick={onAllReports}
            className="rounded-full font-figtree text-xs sm:text-sm font-medium text-[#475569] hover:text-[#059669] hover:bg-[#F0FDF4] px-3 sm:px-4"
          >
            <BarChart3 className="w-4 h-4 sm:mr-1.5" />
            <span className="hidden sm:inline">All Reports</span>
          </Button>
          <Link to={user ? "/account" : "/signup"} data-testid="header-account-link">
            <Button
              variant="ghost"
              className="rounded-full font-figtree text-xs sm:text-sm font-medium text-[#475569] hover:text-[#059669] hover:bg-[#F0FDF4] px-3 sm:px-4"
            >
              <Settings className="w-4 h-4 sm:mr-1.5" />
              <span className="hidden sm:inline">Account</span>
            </Button>
          </Link>
          {rightExtra}
        </div>
      </div>
    </header>
  );
}
